import React from "react";
import "./myskill.css";
import flutter from "../../assest/flutter.svg";
import node from "../../assest/icon-nodejs.svg";
import mongo from "../../assest/icon-mongodb.svg";
import git from "../../assest/icon-git.svg";
import tailwin from "../../assest/icon-tailwindcss.svg";
import socket from "../../assest/icon-socket.svg";
import typescript from "../../assest/icon-typescript.svg";
import sass from "../../assest/icon-sass.svg";
import react from "../../assest/icon-react.svg";
import express from "../../assest/icon-express.svg";

const MySkill = () => {
  const data = [
    {
      id: 1,
      name: "React",
      image: react,
    },
    {
      id: 2,
      name: "Express.js",
      image: express,
    },
    {
      id: 3,
      name: "Flutter",
      image: flutter,
    },
    {
      id: 4,
      name: "Node.js",
      image: node,
    },
    {
      id: 5,
      name: "MongoDb",
      image: mongo,
    },
    {
      id: 6,
      name: "Sass",
      image: sass,
    },
    {
      id: 7,
      name: "Git",
      image: git,
    },
    {
      id: 8,
      name: "Tailwind",
      image: tailwin,
    },
    {
      id: 9,
      name: "Socket.Io",
      image: socket,
    },
    {
      id: 10,
      name: "Type-Script",
      image: typescript,
    },
  ];
  return (
    <div className="my_skill_main">
      <p className="about_me__heading">Skills</p>
      <p className="small_para_about_skill">
        The skills, tools and technologies I am really good at:
      </p>
      <div className="my_skill_section">
        {data.map((item) => {
          return (
            <div className="skill_card" key={item.id}>
              <img src={item.image} alt="skill" className="skill_image" />
              <p className="skill_name">{item.name}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MySkill;
